<template>
  <div class="upgrade-modal">
    <div class="upgrade-modal__wrapper">
      <div class="upgrade-modal__img">
        <CNuxtImg min-height="261px" src="/images/img_free_upgrade.webp" />
        <img src="/images/img_confetti.webp" class="confetti" />
      </div>
      <h2 class="upgrade-modal__title" v-html="$t('oldTranslations.upgradeModal.title')" />
      <div class="upgrade-modal__list">
        <div class="upgrade-modal__item">
          <nuxt-icon name="green-check" />
          <p>{{ $t('oldTranslations.landingV15.greatSex') }} - <span class="crossed">$39</span> <span class="bold">{{ freeWord }}</span></p>
        </div>
        <div class="upgrade-modal__item">
          <nuxt-icon name="green-check" />
          <p>{{ $t('oldTranslations.landingV15.sexWithoutAnx') }} - <span class="crossed">$39</span> <span class="bold">{{ freeWord }}</span></p>
        </div>
        <div class="upgrade-modal__item">
          <nuxt-icon name="green-check" />
          <p>{{ $t('oldTranslations.landingV15.pelvic') }} - <span class="crossed">$29</span> <span class="bold">{{ freeWord }}</span></p>
        </div>
        <div class="upgrade-modal__item">
          <nuxt-icon name="green-check" />
          <p>{{ $t('oldTranslations.landingV15.groin') }} - <span class="crossed">$19</span> <span class="bold">{{ freeWord }}</span></p>
        </div>
      </div>
      <div>
        <p class="upgrade-modal__total">
          {{ $t('oldTranslations.payments.total') }}:
        </p>
        <p class="upgrade-modal__text">
          <span class="crossed">$126</span> {{ $t('oldTranslations.upgradeModal.added') }}
        </p>
      </div>
      <base-button type="black" class="upgrade-modal__cta" @click="$emit('closed')">
        {{ $t('oldTranslations.upgradeModal.cta') }}
      </base-button>
    </div>
  </div>
</template>

<script setup>
defineEmits(['closed']);
const { t } = useI18n();
const freeWord = computed(() => t('oldTranslations.general.free').toLowerCase());
const { mixpanelTrack } = useMixpanel();
onMounted(() => {
  mixpanelTrack('Upgrade pop-up shown');
});

onBeforeUnmount(() => {
  mixpanelTrack('Upgrade pop-up complete');
});
</script>

<style lang="scss">
.upgrade-modal {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding-bottom: 24px;
  max-width: 480px;
  width: 90%;
  border-radius: 16px;

  &__wrapper {
    overflow-y: scroll;
    height: 90dvh;
    padding: 24px;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__img {

    & .confetti {
      position: absolute;
      top: -30px;
      left: 0;
      pointer-events: none;
      width: 105%;
    }
  }

  &__title {
    color: #111113;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;

    & span {
      background: $red;
      color: #fff;
      padding: 2px 4px;
      border-radius: 4px;
    }
  }

  &__list {
    margin-top: 16px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    & .nuxt-icon {
      color: $green;
    }

    & .crossed {
      text-decoration: line-through;
    }

    & .bold {
      font-weight: 700;
      text-transform: capitalize;
    }
  }

  &__total {
    color: rgba(17, 17, 19, 0.50);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 24px */
    margin-top: 24px;
  }

  &__text {
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    color: $red;

    & .crossed {
      color: $black;
      text-decoration: line-through;
    }
  }

  &__cta {
    margin-top: 20px !important;
    box-shadow: 0 14px 13px 0 rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;

    &:active {
      transform: scale(0.95);
    }
  }
}
</style>
